var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-breadcrumb",
        { attrs: { "separator-class": "el-icon-arrow-right" } },
        [
          _c("el-breadcrumb-item", [_vm._v("采购管理")]),
          _c("el-breadcrumb-item", [_vm._v("采购列表")]),
          _c("el-breadcrumb-item", [_vm._v("新增采购入库单")]),
          _c("el-breadcrumb-item", [_vm._v("确认采购入库单")]),
        ],
        1
      ),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "table" },
        [
          _c("ul", [
            _c("li", [
              _vm._v(
                "采购换货编号：" + _vm._s(_vm.content.purchaseExchangeOrderNo)
              ),
            ]),
            _c("li", [_vm._v("制单人：" + _vm._s(_vm.content.createdName))]),
            _c("li", [
              _vm._v(
                "制单时间：" + _vm._s(_vm.$moment(_vm.content.createdTime))
              ),
            ]),
          ]),
          _c(
            "el-table",
            { attrs: { data: _vm.addPurchaseExchangeOrderDtoList } },
            [
              _c("el-table-column", {
                attrs: { label: "序号", type: "index", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { label: "供应商" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.supplierName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "创建人", width: "120px; " },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.createdName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "采购部门" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.purchaseOrgName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "采购仓库", width: "120px;" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "p",
                          _vm._l(scope.row.depotBaseDtoList, function (items) {
                            return _c("span", { key: items.id }, [
                              _vm._v(
                                _vm._s(items.inDepotName) +
                                  "(" +
                                  _vm._s(items.depotQuantity) +
                                  ")"
                              ),
                            ])
                          }),
                          0
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "采购商品",
                  width: "140px;",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.purchaseProdName)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商品类型" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.purchaseProdType == 1
                          ? _c("span", [_vm._v("商品")])
                          : _c("span", [_vm._v("赠品")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "商品图片" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.purchaseProdImage
                          ? _c("img", {
                              staticStyle: { width: "50px", height: "50px" },
                              attrs: {
                                src:
                                  _vm.ImgHttps +
                                  scope.row.purchaseProdImage.split(",")[0],
                                alt: "",
                              },
                            })
                          : _c("span", [_vm._v("/")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "品牌" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.purchaseProdBrandName)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "规格" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(scope.row.purchaseProdSpecificationName)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "采购单价" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.purchaseProdPrice)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "采购金额" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.exchangeProdAmount)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "入库数量" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.exchangeProdQuantity)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "未入库数量", width: "120px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(_vm._s(scope.row.notInDepotQuantity)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("p", { staticStyle: { height: "45px" } }),
      _c(
        "div",
        { staticClass: "botton" },
        [
          _c("p", [_vm._v("总数量：" + _vm._s(_vm.end.number))]),
          _c("p", [_vm._v("总金额：" + _vm._s(_vm.end.totalPrice))]),
          _c("p", [_vm._v("未入库数：" + _vm._s(_vm.end.notInDepotQuantity))]),
          _c(
            "el-button",
            { attrs: { size: "mini" }, on: { click: _vm.cancelEvent } },
            [_vm._v("取消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: { click: _vm.submitEvent },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("确认采购入库单")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }